<template>
<div>
    <!-- Animate -->
    <div class="col-md-12 mb-3">
        <div class="row">
            <div class="col-md-12">
                <label>Create Animation</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <input type="checkbox" id="delete_lines_below_threshold_check" v-model="form.animate_tracing" />
                        </div>
                    </div>
                    <input type="number" class="form-control" name="r_step" v-model="form.animate_thickness" :class="
                                    form.errors.animate_thickness
                                        ? 'is-invalid'
                                        : ''
                                " :disabled="!form.animate_tracing" />

                    <div class="input-group-append">
                        <select class="custom-select" name="animate_color_type" v-model="form.animate_color_type" :class="
                                        form.errors.animate_color_type
                                            ? 'is-invalid'
                                            : ''
                                    " :disabled="!form.animate_tracing">
                            <option value="rgb" selected>RGB</option>
                            <option value="angle_hue" disabled>angle hue</option>
                        </select>
                    </div>
                    <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                                    .animate_thickness">
                        {{ error }}
                    </span>
                    <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                                    .animate_color_type">
                        {{ error }}
                    </span>
                </div>
            </div>

            <div class="form-group col-md-12">
                <div class="form-group" v-show="
                                form.animate_color_type == 'rgb' &&
                                    form.animate_tracing
                            ">
                    <label>Color:</label><br />
                    <v-swatches v-model="form.animate_color_rgb" inline></v-swatches>
                    <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                                    .animate_color_rgb">
                        {{ error }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!-- draws -->
    <div class="row">
        <div class="col-md-12">
            <div class="card bg-white border-dark">
                <div class="card-header">Define Draw Parameters</div>
                <div class="card-body border-top">
                    <div class="alert alert-danger" v-show="draw.validations.length > 0">
                        <span v-for="(validation, index) in draw.validations" :key="index">{{ validation }} <br /></span>
                    </div>
                    <div class="form-row">
                        <!-- draw -->
                        <div class="form-group col-md-6">
                            <label>Image name</label>

                            <input type="text" class="form-control" name="name" v-model="draw.name" />
                        </div>

                        <div class="form-group col-md-6">
                            <label>Background</label>
                            <select class="custom-select" name="background" v-model="draw.background">
                                <option value="original" selected>original</option>
                                <option value="cropped">cropped</option>
                                <option value="tubeness">tubeness</option>
                                <option value="hessian">hessian</option>
                                <option value="visualized_hessian">visualized hessian</option>
                                <option value="white">white</option>
                                <option value="black">black</option>
                            </select>
                        </div>
                    </div>

                    <!-- draw fiber network -->
                    <div class="form-row">
                        <div class="form-group col-md-4 my-auto">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="fiber_network" :class="
                                            form.errors.fiber_network
                                                ? 'is-invalid'
                                                : ''
                                        " v-model="draw.fiber_network" />
                                <label class="custom-control-label" for="fiber_network">Draw fiber network</label>
                            </div>
                        </div>

                        <div class="form-group col-md-4" v-show="draw.fiber_network">
                            <label>Color Type</label>
                            <select class="custom-select" name="network_color_type" v-model="draw.network_color_type">
                                <option value="rgb" selected>RGB</option>
                                <option value="angle_hue">Angle hue</option>
                            </select>
                        </div>

                        <div class="form-group col-md-4 " v-show="draw.fiber_network">
                            <label>Network thickness</label>
                            <div class="input-group">
                                <input type="number" class="form-control" name="network_thickness" v-model="draw.network_thickness" />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        px
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-md-12" v-show="
                                    draw.network_color_type == 'rgb' &&
                                        draw.fiber_network
                                ">
                            <label>Color:</label><br />
                            <v-swatches v-model="draw.network_color_rgb" inline></v-swatches>
                        </div>
                    </div>

                    <!-- draw loops -->

                    <div class="form-row">
                        <div class="form-group col-md-4 my-auto">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="loops" v-model="draw.loops" />
                                <label class="custom-control-label" for="loops">Draw loops</label>
                            </div>
                        </div>

                        <div class="form-group col-md-4" v-show="draw.loops">
                            <label>Color Type</label>
                            <select class="custom-select" name="loop_color_type" v-model="draw.loops_color_type">
                                <option value="rgb" selected>RGB</option>
                                <option value="angle_hue">angle hue</option>
                            </select>
                        </div>

                        <div class="form-group col-md-4 " v-show="draw.loops">
                            <label>Loops thickness</label>
                            <div class="input-group">
                                <input type="number" class="form-control" name="loops_thickness " v-model="draw.loops_thickness" min="1" />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        px
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-12" v-show="
                                    draw.loops_color_type == 'rgb' && draw.loops
                                ">
                            <label>Color:</label><br />
                            <v-swatches v-model="draw.loops_color_rgb" inline></v-swatches>
                        </div>
                    
                     <div class="form-group col-md-12">
                    <button class="btn btn-primary pull-right" @click="addDraw">
                        <i class="fa fa-save pr-2"></i><span>Add draw parameter</span>
                    </button>
                    </div>
                    </div>
              

                    <!-- END DRAW LOOPS -->



                    <div class="table-responsive">
                        <table class="table">
                            <thead class="thead-dark">
                                <tr>
                                    <th>
                                        Pos
                                    </th>
                                    <th>
                                        Name
                                    </th>
                                    <th>
                                        Background
                                    </th>
                                    <th>
                                        Network
                                    </th>
                                    <th>
                                        Loops
                                    </th>
                                    <th class="th-fit"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(member, index) in form.draws" :key="index">
                                    <td>{{ index }}</td>
                                    <td>{{ member.name }}</td>
                                    <td>{{ member.background }}</td>
                                    <td>
                                        <span v-if="member.fiber_network" v-bind:style="{
                                                color:
                                                    member.network_color_type ==
                                                    'rgb'
                                                        ? member.network_color_rgb
                                                        : ''
                                            }" class=" text-bold">{{ member.network_thickness }}
                                            px
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="member.loops" v-bind:style="{
                                                color:
                                                    member.loops_color_type ==
                                                    'rgb'
                                                        ? member.loops_color_rgb
                                                        : ''
                                            }" class=" text-bold">
                                            {{ member.loops_thickness }} px
                                        </span>
                                    </td>
                                    <td>
                                        <i class="fa fa-times text-danger" @click="removeDraw(index)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

         </div>
    </div>

</div>
</div>
</div>
</div>
</template>

<script>
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

export default {
    props: ["form"],
    components: {
        VSwatches
    },
    data() {
        return {
            save_form: {
                type: "",
                name: "",
                parameter: "0", //>0
                unit: "px", //// only on save_loop_areas/ option [ ]px, oder option [ ]set_scale_unit, [ ]fiber diameter
                validations: []
            },

            draw: {
                //draw: 'original network 0 0 255 2 name <imagename>_traced only_loops 255 0 0 1', #
                //hinter name: Bildpfad*/
                name: "", //Dateiname
                background: "original"
                    /*
                                   original
                                   cropped
                                   tubeness
                                   hessian
                                   visualized_hessian
                                   white
                                   black
                                   */
                    ,
                fiber_network: "", //TIK YES / NO
                network_color_type: "rgb", // switch angle_hue oder rgb
                network_color_rgb: "", //ausgrauen wenn oben angle_hue ausgewählt wird
                network_thickness: "", // 1-1000
                loops: "", //TIK YES/NO
                loops_color_type: "rgb", // switch angle_hue oder rgb
                loops_color_rgb: "", //ausgrauen wenn oben angle_hue ausgewählt wird
                loops_thickness: "",
                validations: [] // 1-1000
                /* END DRAW*/
            }
        };
    },
    methods: {
        removeDraw(index) {
            this.form.draws.splice(index, 1);
        },
        addDraw() {
            console.log("test");
            this.draw.validations = [];

            if (!this.draw.name) {
                this.draw.validations.push("Name must be set");
            }
            if (
                this.draw.fiber_network &&
                (!this.draw.network_thickness ||
                    this.draw.network_thickness < 1)
            ) {
                this.draw.validations.push("Network thickness must be >0");
            }

            if (
                this.draw.loops &&
                (!this.draw.loops_thickness || this.draw.loops_thickness < 1)
            ) {
                this.draw.validations.push("loops_thickness must be >0");
            }
            if (
                this.draw.loops &&
                this.draw.loops_color_type == "rgb" &&
                !this.draw.loops_color_rgb
            ) {
                this.draw.validations.push("Loop color must be set");
            }
            if (
                this.draw.fiber_network &&
                this.draw.network_color_type == "rgb" &&
                !this.draw.network_color_rgb
            ) {
                this.draw.validations.push("Network color must be set");
            }

            if (this.draw.validations.length < 1) {
                this.form.draws.push(this.copyObject(this.draw));
                this.form.draw.name = "";
            }
        },
        addSave() {
            this.save_form.validations = [];

            if (!this.save_form.type) {
                this.save_form.validations.push("Type must be set");
            }
            if (!this.save_form.name) {
                this.save_form.validations.push("Name must be set");
            }
            if (
                this.save_form.type == "save_loop_areas" &&
                (this.save_form.parameter < 0 ||
                    this.save_form.parameter == "" ||
                    this.save_form.parameter == "")
            ) {
                this.save_form.validations.push(
                    "Parameter must be >0 and unit must be set! "
                );
            }
            if (
                (this.save_form.type != "save_loop_areas" &&
                    this.save_form.parameter < 0) ||
                this.save_form.parameter == ""
            ) {
                this.save_form.validations.push("Parameter must be >0");
            }
            if (this.save_form.validations.length < 1) {
                this.form.saves.push(this.copyObject(this.save_form));
                this.form.save.name = "";
            }
        },
        removeSave(index) {
            this.form.saves.splice(index, 1);
        },
        copyObject(obj) {
            var cp = {};
            for (var o in obj) {
                cp[o] = obj[o];
            }
            return cp;
        },
        submit() {
            axios
                .post("/task", this.form)
                .then(response => {
                    console.log("successful");
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.form.errors = error.response.data.errors;
                    }
                });
        }
    }
};
</script>
